import Vue from 'vue'
import Vuex from 'vuex'
import dataModules from './modules/dataModules.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    dataModules
  }
})
